import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';

import type { TWithClassName } from '@/lib/interfaces/shared';
import cn from '@/packages/cn';

const LinkedIn: FC<TWithClassName> = ({ className }) => {
  return (
    <span className={cn('flex h-7 w-7 items-center justify-center', className)}>
      <FontAwesomeIcon icon={faLinkedin} className='text-[1.375rem] text-gray-900 dark:text-white' />
    </span>
  );
};

export default LinkedIn;
